export function formatDateToDMY(date: string | number | Date | null | undefined): string {
  if (!date) return "Sem data";

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    console.error("Invalid date value:", date);
    return "Invalid date";
  }

  // Se a data está no formato YYYY-MM-DD, trata como data local
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  const offsetBrasilia = -3; 
  const adjustedDate = new Date(parsedDate.getTime() + offsetBrasilia * 60 * 60 * 1000);

  const day = String(adjustedDate.getUTCDate()).padStart(2, "0");
  const month = String(adjustedDate.getUTCMonth() + 1).padStart(2, "0");
  const year = adjustedDate.getUTCFullYear();

  return `${day}/${month}/${year}`;
}

export function parseDMYToDate(
  dateString: string | null | undefined,
): Date | null {
  if (!dateString) return null;

  const parts = dateString.split("/");
  if (parts.length !== 3) return null;

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);

  if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
    return null;
  }

  const date = new Date(year, month, day);

  if (
    date.getDate() !== day ||
    date.getMonth() !== month ||
    date.getFullYear() !== year
  ) {
    return null;
  }

  return date;
}